import * as React from 'react';
import Avatar from '@mui/material/Avatar';
import { Updated } from "../../util/FormattingUtils";
import MyMarker from "../../components/Marker"
import { ObjectCard } from '../../components/ObjectCard';
import Box from "@mui/material/Box";
import { faArrowUp, faArrowDown } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import TravelTimesChart from './TravelTimesChart';
import { Typography } from '@mui/material';

const endpoint = "traveltimes"

const getLabelOrigin = (icon, endpoint) => {
    var iconname = endpoint + "_" + icon.dir.toLowerCase() + ".png";
    var labelAnchor = "";
    const tt = icon.traveltime;
    if (iconname.indexOf("_w") > 0) {
        if (tt * 1 < 10) {
            labelAnchor = new window.google.maps.Point(19, 18);
        } else {
            labelAnchor = new window.google.maps.Point(20, 18);
        }
    } else if (iconname.indexOf("_e") > 0) {
        if (tt * 1 < 10) {
            labelAnchor = new window.google.maps.Point(14, 18);
        } else {
            labelAnchor = new window.google.maps.Point(14, 18);
        }
    } else if (iconname.indexOf("_ne") > 0) {
        if (tt * 1 < 10) {
            labelAnchor = new window.google.maps.Point(16, 19);
        } else {
            labelAnchor = new window.google.maps.Point(15, 19);
        }
    } else if (iconname.indexOf("_nw") > 0) {
        if (tt * 1 < 10) {
            labelAnchor = new window.google.maps.Point(19, 19);
        } else {
            labelAnchor = new window.google.maps.Point(19, 19);
        }
    } else if (iconname.indexOf("_n") > 0) {
        if (tt * 1 < 10) {
            labelAnchor = new window.google.maps.Point(18, 20);
        } else {
            labelAnchor = new window.google.maps.Point(17, 20);
        }
    } else if (iconname.indexOf("_se") > 0) {
        if (tt * 1 < 10) {
            labelAnchor = new window.google.maps.Point(16, 15);
        } else {
            labelAnchor = new window.google.maps.Point(15, 15);
        }
    } else if (iconname.indexOf("_sw") > 0) {
        if (tt * 1 < 10) {
            labelAnchor = new window.google.maps.Point(19, 15);
        } else {
            labelAnchor = new window.google.maps.Point(20, 15);
        }
    } else if (iconname.indexOf("_s") > 0) {
        if (tt * 1 < 10) {
            labelAnchor = new window.google.maps.Point(18, 15);
        } else {
            labelAnchor = new window.google.maps.Point(18, 15);
        }
    }
    return labelAnchor;
}


const getIconUrl = (icon, endpoint) => {
    var iconname = endpoint + "_" + icon.dir.toLowerCase() + ".png";
    iconname = "/mapicons/" + endpoint + "/" + iconname;
    return iconname;
}

const getIcon = (icon, endpoint) => {
    return {
        url: getIconUrl(icon, endpoint),
        anchor: new window.google.maps.Point(18, 15),
        labelOrigin: getLabelOrigin(icon, endpoint)
    };
}

const getLabel = (icon) => {
    return {
        text: icon.traveltime !== "n/a" ? icon.traveltime : "--",
        fontWeight: "bold"
    }
}

const TTMarker = (props) => {
    const icon = props.icon;
    const endpoint = props.module.endpoint;
    const icondef = getIcon(icon, endpoint);
    const label = getLabel(icon);

    return (
        <MyMarker {...props} icondef={icondef} label={label} />
    )
}

const getSize = (tt) => {
    if (tt === 'n\a') return "-sm"; // eslint-disable-line
    if (tt <= 9) return "-sm"
    return "";
}

const TTAvatar = React.forwardRef(function MyComponent(props, ref) {
    const d = props.value;
    const module = props.module;
    let imageUrl = getIconUrl(d, module.endpoint);
    let imageName = "Travel Times";
    return (
        <Avatar alt={imageName} {...props} ref={ref} variant="square" sx={{ height: '45px', width: '45px', objectFit: "contain", bgcolor: "background.default" }} title={module.label + d.displayId}>
            <Box sx={{
                backgroundImage: "url(" + imageUrl + ");",
                width: "100%",
                height: "100%",
                backgroundSize: "contain",
                backgroundRepeat: "no-repeat",
                display: "relative"
            }}
            ><div className={"tt-icon-text tt-icon-text-" + d.dir.toLowerCase() + getSize(d.traveltime)}>{"n/a" === d.traveltime ? "--" : d.traveltime}</div>
            </Box>
        </Avatar>
    )
});

const TTInfoWindow = (props) => {
    const obj = props.icon;
    return (
        <div className="infoWindow">
            <Box sx={{ mb: 2 }}>
                <Typography>{obj.name}</Typography>
                <Updated icon={obj} />
            </Box>
            <TravelTimesChart id={obj.displayId} />
        </div>

    )
}

const showCardContent = (obj) => { return true; }

const TTCardContent = (props) => {
    const obj = props.obj;
    return (
        <TravelTimesChart id={obj.displayId} />
    )
}

const TTCardTitle = (props) => {
    const obj = props.obj;
    return (
        <Box sx={{ display: "flex" }}>
            <Box sx={{ flexGrow: 0, paddingRight: "20px" }}>
                {obj.name}
            </Box>
            <Box sx={{ flexGrow: 1, marginLeft: "auto", textAlign: "right" }}>
                {
                    obj.trend === "DOWN" &&
                    <FontAwesomeIcon icon={faArrowUp} border className="tt-trend-up" size="lg" />
                }
                {
                    obj.trend === "UP" &&
                    <FontAwesomeIcon icon={faArrowDown} border className="tt-trend-down" size="lg" />
                }
            </Box>
        </Box>
    )
}

const subsort = (objects) => {
    const objectsHash = {};
    for (let i = 0; i < objects.length; i++) {
        let obj = objects[i];
        let name = obj.groupName;
        if (!name) name = "";
        if (!objectsHash[name]) {
            objectsHash[name] = [];
        }
        objectsHash[name].push(obj);
    }
    return objectsHash;
}

const module = {
    name: 'Travel Times',
    label: 'Travel Time',
    marker: TTMarker,
    showOnMap: true,
    mapLayerIcon: "/mapicons/traveltimes/traveltimes.png",
    sideBarCard: ObjectCard,
    showOnSidebar: true,
    infoWindow: TTInfoWindow,
    endpoint: endpoint,
    defaultOn: true,
    updateDelay: 0,
    avatar: TTAvatar,
    showCardContent: showCardContent,
    cardContent: TTCardContent,
    cardTitle: TTCardTitle,
    subSort: subsort,
    publishLayer: "tasWebapp.eventicons.enable",
}

export default module;